import AlertCommentFormWrapper from "./AlertCommentFormWrapper";
import AlertCommentForm from "./AlertCommentForm";

export default AlertCommentFormWrapper(AlertCommentForm);
